// @generated by protoc-gen-es v2.11.0 with parameter "target=ts+js"
// @generated from file lease/kiosk/v1/virtual_products.proto (package lease.kiosk.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_lease_kiosk_v1_types } from "./types_pb";

/**
 * Describes the file lease/kiosk/v1/virtual_products.proto.
 */
export const file_lease_kiosk_v1_virtual_products = /*@__PURE__*/
  fileDesc("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", [file_lease_kiosk_v1_types]);

/**
 * Describes the message lease.kiosk.v1.VirtualProductCategory.
 * Use `create(VirtualProductCategorySchema)` to create a new message.
 */
export const VirtualProductCategorySchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 0);

/**
 * Describes the message lease.kiosk.v1.VirtualProductVariant.
 * Use `create(VirtualProductVariantSchema)` to create a new message.
 */
export const VirtualProductVariantSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 1);

/**
 * Describes the message lease.kiosk.v1.ListVirtualProductsRequest.
 * Use `create(ListVirtualProductsRequestSchema)` to create a new message.
 */
export const ListVirtualProductsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 2);

/**
 * Describes the message lease.kiosk.v1.ListVirtualProductsResponse.
 * Use `create(ListVirtualProductsResponseSchema)` to create a new message.
 */
export const ListVirtualProductsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 3);

/**
 * Describes the message lease.kiosk.v1.CreateVirtualProductOrderRequest.
 * Use `create(CreateVirtualProductOrderRequestSchema)` to create a new message.
 */
export const CreateVirtualProductOrderRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 4);

/**
 * Describes the message lease.kiosk.v1.CreateVirtualProductOrderResponse.
 * Use `create(CreateVirtualProductOrderResponseSchema)` to create a new message.
 */
export const CreateVirtualProductOrderResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 5);

/**
 * Describes the message lease.kiosk.v1.UpdateVirtualOrderStatusRequest.
 * Use `create(UpdateVirtualOrderStatusRequestSchema)` to create a new message.
 */
export const UpdateVirtualOrderStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 6);

/**
 * Describes the message lease.kiosk.v1.UpdateVirtualOrderStatusResponse.
 * Use `create(UpdateVirtualOrderStatusResponseSchema)` to create a new message.
 */
export const UpdateVirtualOrderStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 7);

/**
 * Describes the message lease.kiosk.v1.QueryVirtualOrderStatusRequest.
 * Use `create(QueryVirtualOrderStatusRequestSchema)` to create a new message.
 */
export const QueryVirtualOrderStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 8);

/**
 * Describes the message lease.kiosk.v1.QueryVirtualOrderStatusResponse.
 * Use `create(QueryVirtualOrderStatusResponseSchema)` to create a new message.
 */
export const QueryVirtualOrderStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 9);

/**
 * Describes the message lease.kiosk.v1.CancelVirtualOrderRequest.
 * Use `create(CancelVirtualOrderRequestSchema)` to create a new message.
 */
export const CancelVirtualOrderRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 10);

/**
 * Describes the message lease.kiosk.v1.CancelVirtualOrderResponse.
 * Use `create(CancelVirtualOrderResponseSchema)` to create a new message.
 */
export const CancelVirtualOrderResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_kiosk_v1_virtual_products, 11);

/**
 * VirtualProductService handles virtual product browsing, ordering, and fulfillment.
 * Virtual products are items fulfilled by an external 3rd-party API (e.g., golf tee times)
 * rather than physical dispensing from a locker door.
 *
 * @generated from service lease.kiosk.v1.VirtualProductService
 */
export const VirtualProductService = /*@__PURE__*/
  serviceDesc(file_lease_kiosk_v1_virtual_products, 0);

